module.exports = "/favicon.ico";